module.exports = {"rodoTitle":"Klauzula informacyjna RODO","showRodoClause":"Wyświetl klauzulę informacyjną"}


//////////////////
// WEBPACK FOOTER
// ./src/components/RodoClause/translate.json
// module id = 591
// module chunks = 0